//Angular
import { Component, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from "@angular/core";

//Services
import { ComponentHelperService } from "./../../../services/core/component-helper.service";
import { TemplateService } from "./../../../services/settings/template.service";
import { RoutesService } from "../../../services/core/routes.service";
import { CmsComponentService } from "../../../services/cms/cms-component.service";

//Models
import { Subscription } from 'rxjs/Subscription';
import { SeoService } from "../../../services/core/seo.service";
import { DOCUMENT } from "@angular/platform-browser";



@Component({
    template: ""
})

export class NotFoundPageComponent implements OnInit {

    constructor
        (
        private _compiler: Compiler,
        private componentHelper: ComponentHelperService,
        private _elementRef: ViewContainerRef,
        private templateService: TemplateService,
        private cmsComponentService: CmsComponentService,
        @Inject('isBrowser') private isBrowser: boolean,
        private seo: SeoService,
        private renderer: Renderer,
        @Inject(DOCUMENT) private document: any
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        let header: any;
        let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
            header = result;
            let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
                if (result1.Categories) {
                    header.Categories = result1.Categories;

                }
            });
            this.subManager.add(SideMenuData);
        });
        this.subManager.add(headDataSub);
        let notFoundSub = this.templateService.getComponentTemplatePageNotFound("notfoundPageTemplate").subscribe(result => {
             if (result.SeoInformation) {
                result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
            }
            
            if (this.isBrowser) {
                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(result,header);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
            else {
                //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
            }
        },
            //setting 404 page status code
            err => {
                if (!this.isBrowser)
                    return;
                //converting response to json
                let response = err.json();

                //Creating subcomponent whith the selected template to inject                
                let subComponent = this.createSubComponent(response.TemplateHtml,header);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
            }
        )

        this.subManager.add(notFoundSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(result: any,header:any) {

        @Component({
            template: result
        })

        class ChildComponent implements OnInit {

            constructor
                (
                @Inject('isBrowser') private isBrowser: boolean,
                private routesService: RoutesService
                ) {
            }

            private pageIsInit: boolean = false;
            private headerClass: boolean = false;
           footerData: any = result.FooterData;
           headerData: any = header;

            ngOnInit() {
            }

            setAutoHeightAndWeightToLogo() {
                this.headerClass = $("div").hasClass("header-logo");
                if (this.headerClass == false) {
                    //setTimeout(x => this.setAutoHeightAndWeightToLogo(), 5);
                }
                else {
                    $(".header-logo").attr("style", "height:auto!important");
                    $(".header-logo").attr("style", "width:auto!important");
                }
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                this.setAutoHeightAndWeightToLogo();

                this.pageIsInit = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/core/sys/not-found-page.component.ts